





























































































































































































































































































import {
  AuthenticationApi,
  FormsApi,
  PatientApi,
  RefreshAccessTokenRequest,
  ImperfectionInceptionDto2,
  NatureComplaint,
  FeedbackMessage
} from "@/api";
import stateMixin from "@/mixins/state";
import moment from "moment";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
const FilePond = vueFilePond(FilePondPluginFileValidateType);

export default {
  data() {
    return {
      dropdownData: null,
      startSwallowDateMenu: null,
      intakeDateMenu: null,
      intakeTimeMenu: null,
      scrollEndDateMenu: null,
      valid: true,
      myFiles: null,
      requiredFields: [
        "pharmacyContactPerson",
        "discovererComplaint",
        "natureComplaint",
        "startSwallowDate",
        "endScrollDate"
      ],
      errors: {},
      filePond: {
        files: null,
        server: {
          url: process.env.VUE_APP_API,
          process: {
            url: "/api/portal/File/UploadFile",
            method: "POST",
            headers: {
              Authorization: ""
            }
          }
        }
      },

      autocomplete: {
        entries: [],
        isLoading: false,
        model: null,
        search: null,
        error: false
      },

      fields: {
        pharmacyContactPerson: "",
        discovererComplaint: undefined,
        natureComplaint: undefined,
        other: null,
        medicine: null,
        department: "",
        patientId: null,
        startSwallowDate: "",
        intakeDate: null,
        intakeTime: null,
        feedbackMessage: FeedbackMessage.NoFeedbackNecessary,
        feedbackPhoneNumber: null,
        feedbackEmailAddress: null,
        scrollEndDate: "",
        detailedDescriptionMessage: null,
        actionsTakenImmediately: null,
        imageGuid: null
      },

      // Static rules, these fields are always required
      rules: {
        feedbackMessage: [v => !!v || "Terugkoppeling is verplicht"],
        isComplaint: [v => v !== null || "Klacht/Foto opvraag is verplicht"],
        contactPerson: [v => v !== null || "Contactpersoon is verplicht"]
      }
    };
  },
  name: "ReportImperfectionInceptionAlkmaar",
  mixins: [stateMixin],
  components: {
    FilePond
  },
  methods: {
    getDropdownData: async function() {
      this.setState(this.states.LOADING);
      try {
        const api = new FormsApi();
        const { data } = await api.formsGetDropdownDataAlkmaar();

        this.dropdownData = data;
        this.setState(this.states.INITIAL);
      } catch {
        this.setState(this.states.ERROR);
      }
    },
    submit: async function() {
      this.$refs.form.validate();

      if (this.valid) {
        this.setState(this.states.LOADING);
        const api = new FormsApi();
        try {
          const result = await api.formsReportImperfectionInceptionAlkmaar({
            pharmacyContactPerson: this.fields.pharmacyContactPerson,
            discovererComplaint: this.fields.discovererComplaint,
            natureComplaint: this.fields.natureComplaint,
            other: this.fields.other,
            medicine: this.fields.medicine,
            department: this.fields.department,
            patientId: this.autocomplete?.model?.patientId,
            startSwallowDate: this.fields.startSwallowDate,
            intakeDate: this.fields.intakeDate,
            intakeTime: this.fields.intakeTime,
            scrollEndDate: this.fields.scrollEndDate,
            feedbackMessage: this.fields.feedbackMessage,
            feedbackPhoneNumber: this.fields.feedbackPhoneNumber,
            feedbackEmailAddress: this.fields.feedbackEmailAddress,
            detailedDescriptionMessage: this.fields.detailedDescriptionMessage,
            actionsTakenImmediately: this.fields.actionsTakenImmediately,
            imageGuid: this.fields.imageGuid
          } as ImperfectionInceptionDto2);

          this.setState(this.states.COMPLETED);

          (this.$refs.form as HTMLFormElement).reset();
        } catch (e) {
          this.setState(this.states.ERROR);
        }
      }
    },

    patientAndMedicineRules(isPatient: boolean) {
      if (
        (this.fields.natureComplaint &&
          this.fields.natureComplaint === NatureComplaint.DamagedBag) ||
        this.fields.natureComplaint === NatureComplaint.DamagedMedication ||
        this.fields.natureComplaint === NatureComplaint.DamagedRolls ||
        this.fields.natureComplaint === NatureComplaint.DamagedPackaging ||
        this.fields.natureComplaint === NatureComplaint.MissingAddressLabels ||
        this.fields.natureComplaint === NatureComplaint.MissingMedication ||
        this.fields.natureComplaint === NatureComplaint.MissingRolls ||
        this.fields.natureComplaint ===
          NatureComplaint.MissingAdministrationList ||
        this.fields.natureComplaint === NatureComplaint.MissingBag ||
        this.fields.natureComplaint === NatureComplaint.TooMuchMedication ||
        this.fields.natureComplaint === NatureComplaint.TooMuchRolls ||
        this.fields.natureComplaint === NatureComplaint.WrongAddressLabel ||
        this.fields.natureComplaint === NatureComplaint.WrongMedication
      ) {
        if (isPatient) {
          return [v => !!v || "Patient is verplicht"];
        } else {
          return [v => !!v || "Geneesmiddel is verplicht"];
        }
      }
      return [];
    },
    async beforeAddFile() {
      const state = this.$store.getters["auth/getAuth"];
      const api = new AuthenticationApi();
      const request: RefreshAccessTokenRequest = {
        accessToken: state.accessToken,
        refreshToken: state.refreshToken
      };
      const { data } = await api.authenticationRefreshAccessToken(request, {
        transformRequest: (data: any, headers: any) => {
          delete headers.common["Authorization"];
          return data;
        }
      });
      this.$store.dispatch("auth/setAuth", data);
      this.filePond.server.process.headers[
        "Authorization"
      ] = `Bearer ${data.accessToken}`;
      return true;
    },
    processUploadedFile(err, file: FilePondFile) {
      this.fields.imageGuid = file.serverId;
    },
    getErrors(property: string) {
      const key = property.toLowerCase();
      return this.errors[key] || this.errors[`$.${key}`] || [];
    },
    resetErrors(property: string) {
      const key = property.toLowerCase();
      this.$delete(this.errors, key);
    }
  },

  computed: {
    pharmacyContactPersonRules() {
      if (
        this.requiredFields &&
        this.requiredFields.indexOf("pharmacyContactPerson") > -1
      ) {
        return [v => !!v || "Contactpersoon is verplicht"];
      }
      return [];
    },
    natureComplaintRules() {
      if (
        this.requiredFields &&
        this.requiredFields.indexOf("natureComplaint") > -1
      ) {
        return [v => !!v || "Aard van klacht is verplicht"];
      }
      return [];
    },
    discovererComplaintRules() {
      if (
        this.requiredFields &&
        this.requiredFields.indexOf("discovererComplaint") > -1
      ) {
        return [v => !!v || "Ontdekker van klacht is verplicht"];
      }
      return [];
    },

    startSwallowDateRules() {
      if (
        this.requiredFields &&
        this.requiredFields.indexOf("startSwallowDate") > -1
      ) {
        return [v => !!v || "Startslikdatum is verplicht"];
      }
      return [];
    }
  },
  watch: {
    "autocomplete.search": _.debounce(function(val) {
      if (!val) {
        return;
      }
      if (val.length < 2) {
        return;
      }
      let self = this;
      this.autocomplete.isLoading = true;

      const api = new PatientApi();
      api
        .patientSearchPatients({
          filter: val
        })
        .then(function(res) {
          self.autocomplete.entries = res.data;
          self.autocomplete.isLoading = false;
          self.autocomplete.error = false;
        })
        .catch(function(err) {
          self.autocomplete.isLoading = false;
          self.autocomplete.error = true;
        });
    }, 1000)
  },
  mounted() {
    this.getDropdownData();
  }
};
